// Custom dot navigation for mobile product gallery slider
// Assumes: .slider-dots container exists after .slider__grid in mobile slider

document.addEventListener('DOMContentLoaded', function() {
  var mobileSliders = document.querySelectorAll('.custom-gallery-mobile .custom-gallery-slider');
  mobileSliders.forEach(function(slider) {
    var sliderGrid = slider.querySelector('.slider__grid');
    var slides = sliderGrid ? sliderGrid.querySelectorAll('.slider__item') : [];
    var dotsContainer = slider.querySelector('.slider-dots');
    var sliderTrack = slider.querySelector('.slider');
    if (!dotsContainer || !slides.length || !sliderTrack) return;

    // Create dots
    dotsContainer.innerHTML = '';
    slides.forEach(function(_, idx) {
      var dot = document.createElement('button');
      dot.className = 'slider-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
      if (idx === 0) dot.classList.add('active');
      dot.addEventListener('click', function() {
        sliderTrack.scrollTo({ left: idx * sliderTrack.clientWidth, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
    });

    // Update active dot on scroll
    sliderTrack.addEventListener('scroll', function() {
      var slideWidth = sliderTrack.clientWidth;
      var idx = Math.round(sliderTrack.scrollLeft / slideWidth);
      dotsContainer.querySelectorAll('.slider-dot').forEach(function(dot, i) {
        dot.classList.toggle('active', i === idx);
      });
    });
  });
});
